// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3k2yd","content":"styles_content__CJHc9","row":"styles_row__1TEQ3","footer":"styles_footer__2aRkT","phraseLength":"styles_phraseLength__1xMZc"};